import gql from 'graphql-tag'
import { EventDetailsFragment } from 'src/graphql/fragments/EventDetailsFragment'
import { Event } from 'src/types/fam-graphql'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'

const query = gql`
  query eventBySlug($slug: String!) {
    eventBySlug(slug: $slug) {
      ...EventDetailsFragment
    }
  }
  ${EventDetailsFragment}
`

const transformer = ({ eventBySlug }: { eventBySlug: Event }): any =>
  eventBySlug

type variables = {
  slug: string
}

export default queryServiceCreator<variables>(query, transformer)
